/* Logo.jsx — FINAL — copy into src/components/Logo.jsx */

export function Logo({ size = 'md', dark = false }) {
    const s = {
      lg: { iw:64, ih:25, word:'26px', tag:'7px',   lock:{w:7,h:9},   gap:'14px', div:'5px 0' },
      md: { iw:46, ih:18, word:'19px', tag:'6px',   lock:{w:6,h:7},   gap:'10px', div:'4px 0' },
      sm: { iw:34, ih:14, word:'14px', tag:'5px',   lock:{w:5,h:6},   gap:'8px',  div:'3px 0' },
    }[size];
  
    const lockColor = dark ? 'rgba(255,255,255,0.25)' : '#9A9088';
  
    return (
      <div style={{ display:'flex', alignItems:'center', gap: s.gap }}>
  
        {/* Eye mark — F1 approved shape */}
        <svg width={s.iw} height={s.ih} viewBox="0 0 88 34" fill="none">
          <path
            d="M4 17 C4 17 20 2 44 2 C68 2 84 17 84 17 C84 17 68 32 44 32 C20 32 4 17 4 17Z"
            stroke="#C4790A" strokeWidth="2.4"
            fill={dark ? "rgba(253,243,224,0.06)" : "rgba(253,243,224,0.35)"}
            strokeLinejoin="round"
          />
          <circle cx="44" cy="17" r="9.5"
            fill={dark ? "rgba(253,243,224,0.06)" : "#FDF3E0"} />
          <circle cx="44" cy="17" r="6.5" fill="#C4790A" />
          <circle cx="47" cy="14" r="2.2" fill="white" opacity="0.92" />
        </svg>
  
        {/* Wordmark + divider + tagline + lock */}
        <div style={{ display:'flex', flexDirection:'column' }}>
  
          <span style={{
            fontFamily:"'Cormorant Garamond', serif",
            fontSize: s.word, fontWeight: 500,
            color: dark ? '#fff' : 'var(--text)',
            letterSpacing: '0.01em', lineHeight: 1.1
          }}>
            100<em style={{ fontStyle:'italic', color:'#C4790A' }}>Views</em>Only
          </span>
  
          <div style={{
            height: '1px',
            background: dark ? 'rgba(196,121,10,0.4)' : 'rgba(196,121,10,0.5)',
            margin: s.div
          }} />
  
          {/* Tagline row with lock at the end */}
          <div style={{ display:'flex', alignItems:'center', gap:'4px' }}>
            <span style={{
              fontFamily:"'Inter', sans-serif",
              fontSize: s.tag, fontWeight: 600,
              letterSpacing: '0.18em', textTransform: 'uppercase',
              color: dark ? 'rgba(255,255,255,0.3)' : 'var(--text-muted)',
              lineHeight: 1, whiteSpace: 'nowrap'
            }}>
              Canada's Creator Platform
            </span>
            {/* Lock icon — the period that means something */}
            <svg width={s.lock.w} height={s.lock.h} viewBox="0 0 10 13" fill="none"
              style={{ flexShrink:0, marginBottom:'1px' }}>
              <rect x="1" y="6" width="8" height="6" rx="1.5" fill={lockColor} />
              <path d="M3 6 L3 3.8 C3 2.3 3.9 1 5 1 C6.1 1 7 2.3 7 3.8 L7 6"
                stroke={lockColor} strokeWidth="1.3" fill="none" strokeLinecap="round" />
            </svg>
          </div>
  
        </div>
      </div>
    );
  }
  
  /* Usage:
     <Logo />                nav, light bg (default md)
     <Logo size="lg" />      hero / landing page
     <Logo size="sm" />      footer
     <Logo dark />           emails, admin, dark headers
     <Logo size="lg" dark /> email hero
  */